import { makePaginationState, STATUSES } from 'app/utils/redux';

import * as t from './types';

const initialState = {
  stories: makePaginationState(),
  communities: makePaginationState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    // fetch user stories
    case `${t.FETCH_MY_STORIES}_PENDING`:
      return {
        ...state,
        stories: {
          ...state.stories,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_MY_STORIES}_SUCCESS`:
      return {
        ...state,
        stories: {
          ...state.stories,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: state.stories.pagination.items.concat(
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_MY_STORIES}_ERROR`:
      return {
        ...state,
        stories: {
          ...state.stories,
          status: STATUSES.ERROR,
        },
      };

    case `${t.FETCH_MY_COMMUNITIES}_PENDING`:
      return {
        ...state,
        communities: {
          ...state.communities,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_MY_COMMUNITIES}_SUCCESS`:
      return {
        ...state,
        communities: {
          ...state.communities,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: state.communities.pagination.items.concat(
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_MY_COMMUNITIES}_ERROR`:
      return {
        ...state,
        communities: {
          ...state.communities,
          status: STATUSES.ERROR,
        },
      };

    case `${t.DELTE_COMMUNITY_POST}_SUCCESS`:
      return {
        ...state,
        communities: {
          ...state.communities,
          pagination: {
            ...state.communities.pagination,
            items: state.communities.pagination.items.filter(
              (item) => item.id !== action.meta.id
            ),
          },
        },
      };

    // reset
    case t.RESET:
      return {
        ...state,
        stories: makePaginationState(),
        communities: makePaginationState(),
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/studio/myPage/reducer.js